type NavigationProps = {
    event?: any;
    id: string;
    smallScreen?: boolean;
    isCareSite: boolean;
}

export const navigateToAnchor = (props: NavigationProps ) => {
    if (!props.id) {
        return;
    }

    const parsedId = props.id.includes('#') ? props.id.replace('#', '') : props.id;

    if (props.event) {
        props.event.preventDefault();
    }

    /* The offset is the root `scroll-padding-top` (see style.css), which the browser's own fragment jump
       honours too. The header is sticky and in flow, so if it collapses mid-scroll the target moves up by
       exactly the height it lost and still lands flush under it. A header that hides on scroll-down has
       no padding, but slides back in on scroll-up, so an upward jump clears its full height. */
    const scrollToElement = (element: HTMLElement) => {
        const rootStyle = getComputedStyle(document.documentElement);
        const scrollPadding = parseFloat(rootStyle.scrollPaddingTop) || 0;
        const headerHeight = parseFloat(rootStyle.getPropertyValue('--header-height')) || 0;
        const elementTop = element.getBoundingClientRect().top + window.scrollY;

        const downwardTarget = elementTop - scrollPadding;
        const isUpward = downwardTarget < window.scrollY;

        window.scrollTo({
            top: isUpward ? elementTop - Math.max(scrollPadding, headerHeight) : downwardTarget,
            behavior: 'smooth'
        });
    };

    const element = document.getElementById(parsedId);

    if (element) {
        scrollToElement(element);
    } else {
        const observer = new MutationObserver((mutations, obs) => {
            const element = document.getElementById(parsedId);
            if (element) {
                scrollToElement(element);
                obs.disconnect();
                clearTimeout(timeoutId); // Clear the timeout if element is found
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Set a timeout to disconnect the observer after 5 seconds
        const timeoutId = setTimeout(() => {
            observer.disconnect();
        }, 5000);
    }

    // Get the current URL and append the anchor id
    const url = new URL(window.location.href);
    url.hash = parsedId;
    const newUrl = url.toString();

    // Update the URL without reloading the page or scrolling
    history.replaceState({}, '', newUrl);
};
